import { createSelector } from 'reselect'
import type { State } from 'store/types'

const selectDomain = (state: State) => state.system

export const selectRanges = createSelector([selectDomain], ({ ranges }) => ranges)
